export default {
  slots: {
    root: 'w-full',
  },
}
